import { useCallback } from 'react';
import { TValidationMethod } from 'js/utils/Validation/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from './helpers';
import { useGetFormFieldValue } from '../../../../hooks';
import { useWithRecordLevelValidation } from '../useWithRecordLevelValidation';

export const useRomanianIdFieldValidation = ({ fieldName }: { fieldName: string }) => {
    const translate = useComponentTranslations();
    const getFormFieldValue = useGetFormFieldValue();
    const withRecordLevelValidation = useWithRecordLevelValidation({ fieldName });

    const romanianIdValidate = useCallback<TValidationMethod<string>>(async (value) => {
        const birthdate = getFormFieldValue('birthdate');
        const sex = getFormFieldValue('sex');

        if (!birthdate || !sex) {
            return translate('playtech.mobile.system.form.romanianID.internal.emptyGenderBirth');
        }

        const [idGenderCentury, idBirthDate, idCountryZone, idSerialNumber, idCheckSum] = value
            .split(/(\w{1})(\w{6})(\w{2})(\w{3})(\w{1})/)
            .filter(portion => portion !== '');
        const [year, month, day] = birthdate.split('-');
        const isCorrectBirthdate = idBirthDate === year.slice(-2) + month + day;
        const isCorrectSerialNumber = idSerialNumber?.length === 3;

        const isValidField = helpers.verifyCenturyWithGender(Number(idGenderCentury), Number(year), sex)
            && isCorrectBirthdate
            && helpers.verifyCountryZone(parseInt(idCountryZone))
            && isCorrectSerialNumber
            && helpers.verifyCheckSum(value, Number(idCheckSum));

        if (!isValidField) {
            return translate('playtech.mobile.system.form.romanianID.internal.invalidID');
        }
    }, [getFormFieldValue, translate]);

    return withRecordLevelValidation(romanianIdValidate);
};
